<template>
  <!-- 月度指标 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">故障报警栏目</span>
    </div>
    <div class="main">
      <div class="headerUnit">
        <span style="width: 100px;margin-left: 37px;">报警名称</span>
        <span style="width: 130px">报警内容</span>
        <!-- <span style="width: 90px">报警级别</span> -->
        <span style="width: 140px">报警时间</span>
      </div>
      <div class="dataWrapBox" id="dataWarp" @scroll.prevent>
        <div class="dataWrap" id="ulDiv" @scroll.prevent>
          <div
            @scroll.prevent
            class="tableItem"
            v-for="(item, index) in dataList"
            :key="item.id"
            :style="{ background: index % 2 == 0 ? 'rgba(0,115,255,0.11)' : 'rgba(0,80,186,0.10);' }"
          >
            <a-row>
              <a-col :span="8">
                <span style="min-width: 60px" v-if="item.grade !== '重要'">{{ item.title }}</span>
                <span style="min-width: 60px; color: #f5222d" v-else>{{ item.title }}</span>
              </a-col>
              <a-col :span="8">
                <div style="min-width: 220px" class="tableItemDiv">
                  <a-tooltip>
                    <template slot="title">{{ item.content }}</template>
                    <span v-if="item.grade !== '重要'" >{{ item.content }}</span>
                    <span style="color: #f5222d" v-else>{{ item.content }}</span>
                  </a-tooltip>
                </div>
              </a-col>
              <a-col :span="8">
                <!-- <span style="min-width: 60px">{{ item.grade }}</span> -->
                <span style="min-width: 60px" v-if="item.grade !== '重要'">{{ item.time }}</span>
                <span style="min-width: 60px; color: #f5222d" v-else>{{ item.time }}</span>
              </a-col>
            </a-row>
          </div>
        </div>
        <div id="ulDiv2"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import chartResize from '@/mixin/chart-resize'
export default {
  name: 'FaultAlarm',
  components: {},
  data() {
    return {
      queryUrl: 'pipe-network/water_works_malfunctions/page',
      speed: 50,
      colee: '',
      colee1: '',
      colee2: '',
      dataList: [],
    }
  },

  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      let data = {
        disposeResult: 0,
        sysTab: 1,
        sysType: 3,
      }
      this.$http.get(this.queryUrl, { params: data }).then(({ data }) => {
        data.list.map((item) => {
          this.dataList.push({
            title: item.deviceName,
            content: item.malfunctionCause,
            time: item.createTime,
            grade: item.malfunctionLevel,
            id: item.id,
            disposeResult: item.disposeResult,
          })
        })
        // console.log(JSON.stringify(this.dataList))
        this.getKanbanData()
      })
    },
    getKanbanData() {
      console.log(this.dataList.length)
      if (this.dataList.length > 2) {
        this.$nextTick(() => {
          this.goScroll()
        })
      }
    },
    goScroll() {
      let vm = this
      this.colee2 = document.getElementById('ulDiv2')
      this.colee1 = document.getElementById('ulDiv')
      this.colee = document.getElementById('dataWarp')
      this.colee2.innerHTML = this.colee1.innerHTML // 克隆colee1为colee2

      let MyMar1 = setInterval(this.Marquee1, this.speed) // 设置定时器
      // 鼠标移上时清除定时器达到滚动停止的目的

      this.colee.onmouseover = function () {
        clearInterval(MyMar1)
      }

      this.colee.onmouseout = function () {
        MyMar1 = setInterval(() => {
          vm.Marquee1()
        }, vm.speed)
      }

      this.$once('hook:beforeDestroy', () => {
        clearInterval(MyMar1)
        MyMar1 = null
      })
    },
    Marquee1() {
      // 当滚动至colee1与colee2交界时
      // console.log(this.colee2.offsetTop,this.colee.scrollTop,this.colee1.offsetHeight);
      if (this.colee2.offsetTop - this.colee.scrollTop <= 60) {
        this.colee.scrollTop -= this.colee1.offsetHeight // colee跳到最顶端
      } else {
        this.colee.scrollTop++
      }
    },
  },
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 221px;
  width: 540px;
  background: url(~@/assets/myImg/h_9_gzbjlm_box.png) no-repeat;
  background-size: cover;
  position: relative;
  .img-title {
    position: absolute;
    position: relative;
    bottom: 18px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;
    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
    img {
      width: 264px;
      height: 40px;
    }
  }
  .main {
    height: 185px;
    width: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    padding: 0 10px;
    position: absolute;
    top: 30px;
    .headerUnit {
      width: 100%;
      height: 30px;
      background-image: linear-gradient(270deg, rgba(7, 42, 80, 0.35) 0%, rgba(84, 169, 255, 0.25) 100%);
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      justify-content: space-between;
      span {
        text-align: left;
        display: block;
        margin-left: 10px;
        font-family: MicrosoftYaHeiSemibold;
        font-size: 14px;
        color: #10c0ff;
        font-weight: 600;
      }
    }
    .dataWrapBox {
      height: 150px;
      width: 100%;
      overflow-x: hidden;
      .dataWrap {
        width: 100%;
        .tableItem {
          height: 40px;
          width: 100%;
          min-height: 30px;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          align-items: center;
          .tableItemDiv {
            font-family: MicrosoftYaHeiSemibold;
            font-size: 15px;
            color: #ffffff;
            font-weight: 600;

            span {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          span {
            display: inline-block;
            min-width: 40px;
            max-width: 200px;
            font-family: MicrosoftYaHeiSemibold;
            font-size: 15px;
            color: #ffffff;
            font-weight: 600;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }

    .tableItem {
      height: 40px;
      width: 100%;
      min-height: 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      .tableItemDiv {
        font-family: MicrosoftYaHeiSemibold;
        font-size: 15px;
        color: #ffffff;
        font-weight: 600;

        span {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      span {
        display: inline-block;
        min-width: 40px;
        max-width: 200px;
        font-family: MicrosoftYaHeiSemibold;
        font-size: 15px;
        color: #ffffff;
        font-weight: 600;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}

.dataWrapBox::-webkit-scrollbar {
  width: 0 !important;
}
.dataWrapBox::-webkit-scrollbar {
  -ms-overflow-style: none;
}
.dataWrapBox::-webkit-scrollbar {
  overflow: -moz-scrollbars-none;
}
</style>
